export default "__VITE_ASSET__watACqXp__"